'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

var _container = require('@hixme-ui/container');

var _container2 = _interopRequireDefault(_container);

var _tabTypes = require('./tab-types');

var _tabTypes2 = _interopRequireDefault(_tabTypes);

var _components = require('./components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// hixme-ui
var Tabs = function (_React$Component) {
  (0, _inherits3.default)(Tabs, _React$Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      id: _this.props.id,
      activeIndex: _this.props.initWithIndex
    }, _this.handleTabClick = function (clickedIndex) {
      _this.setState({
        activeIndex: clickedIndex
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _container2.default,
        {
          flex: true,
          noPadding: true,
          direction: this.props.direction === 'row' ? 'column' : 'row',
          width: '100%',
          height: '100%'
        },
        _react2.default.createElement(
          _container2.default,
          { flex: true, noPadding: true, direction: this.props.direction },
          this.props.list && this.props.list.map(function (tab, index) {
            return _react2.default.createElement(
              _container2.default,
              {
                flex: true,
                noPadding: true,
                key: '' + tab.name + _this2.props.id + 'tab',
                margin: '0 15px 0 0'
              },
              _react2.default.createElement(
                'div',
                { style: { height: _this2.props.height } },
                _react2.default.createElement(
                  _tabTypes2.default,
                  (0, _extends3.default)({
                    onClick: function onClick() {
                      return _this2.handleTabClick(index);
                    },
                    onFocus: function onFocus() {
                      return _this2.handleTabClick(index);
                    }
                  }, _this2.props.tabStyles, {
                    active: _this2.state.activeIndex === index
                  }),
                  _react2.default.createElement(
                    _container2.default,
                    {
                      flex: true,
                      noPadding: true,
                      'data-tip': true,
                      'data-for': tab.name
                    },
                    _react2.default.createElement(
                      _text2.default,
                      {
                        style: { outline: 'none', width: '100%' },
                        a: true,
                        tabIndex: index + 1,
                        black: _this2.state.activeIndex === index,
                        light: _this2.state.activeIndex !== index,
                        cursor: 'pointer'
                      },
                      tab.name
                    ),
                    tab.state && _react2.default.createElement(
                      _container2.default,
                      {
                        flex: true,
                        noPadding: true,
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft: '5px'
                      },
                      tab.message && _react2.default.createElement(
                        _reactTooltip2.default,
                        { id: tab.name, effect: 'solid' },
                        tab.message
                      ),
                      _react2.default.createElement(_components.StateIndicator, { state: tab.state })
                    )
                  )
                )
              )
            );
          })
        ),
        _react2.default.createElement(
          _container2.default,
          {
            flex: true,
            noPadding: true,
            direction: this.props.direction,
            height: '100%',
            width: '100%'
          },
          this.props.list && this.props.list.map(function (tab, index) {
            if (_this2.state.activeIndex === index) {
              return _react2.default.createElement(
                'div',
                {
                  key: '' + tab.name + _this2.props.id + 'content',
                  style: { width: '100%' }
                },
                tab.content
              );
            }
            return null;
          })
        )
      );
    }
  }]);
  return Tabs;
}(_react2.default.Component);

Tabs.displayName = 'Tabs';

Tabs.propTypes = {
  direction: _propTypes2.default.string,
  height: _propTypes2.default.string,
  id: _propTypes2.default.string.isRequired,
  initWithIndex: _propTypes2.default.number,
  list: _propTypes2.default.array.isRequired,
  tabStyles: _propTypes2.default.object
};

Tabs.defaultProps = {
  direction: 'row',
  height: 'auto',
  initWithIndex: 0,
  styles: {},
  tabStyles: {}
};

exports.default = Tabs;
//# sourceMappingURL=Tabs.js.map


//////////////////
// WEBPACK FOOTER
// ../tabs/lib/Tabs.js
// module id = 763
// module chunks = 0